module.exports = __webpack_public_path__ + "images/workout-screen-mirror-open.png";